import React, { useState, useEffect, useRef } from 'react';
import { Button, Badge, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Link } from "react-router-dom";
import Select from "react-select";
import idly from '../../../../images/items/idly.png';
import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import $ from "jquery";

const Assign_Vessel_Cat = () => {

        const onInit = () => {
            //   console.log('lightGallery has been initialized');
        };
    
        const [selectedOption, setSelectedOption] = useState(null);
            
        
            const cookwarecat_options = [
                { value: "1", label: "Vessels" },
                { value: "2", label: "Utensils" },
            ];
        
            const cookwaresubcat_options = [
                { value: "1", label: "Tawa" },
                { value: "2", label: "Kadai" },
                { value: "3", label: "Karandi" },
                { value: "4", label: "Tongs" },
                { value: "5", label: "Pot" },
                { value: "6", label: "Cooker" },
            ];
        
            const cookware_options = [
                { value: "1", label: "10 L - Vessel" },
                { value: "2", label: "12-Inch spoon" },
                { value: "3", label: "5L- Vessel" },
                { value: "4", label: "Non-Stick Tawa" },
                { value: "5", label: "Spotted LAdle" },
                { value: "6", label: "5L Bucket" },
            ];
    
        const tableRef = useRef(null);
        useEffect(() => {
            if (tableRef.current) {
                if (!$.fn.dataTable.isDataTable(tableRef.current)) {
                    $(tableRef.current).DataTable({
                        "responsive": true,
                        //   "aaSorting": [],
                        "ordering": false,
                        "paging": false,
                        "language": {
                            "lengthMenu": "Show _MENU_",
                        },
                        "dom":
                            "<'row'" +
                            // "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
                            // "<'col-sm-12 d-flex align-items-center justify-content-end mb-2'f>" +
                            ">" +
                            "<'table-responsive'tr>" +
                            "<'row'" +
                            // "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
                            // "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
                            ">"
                    });
                }
            }
        }, []);
    
        const styles = {
            tableContainer: {
                maxHeight: "300px", // scroll height
                overflowY: "auto",
            },
            stickyHeader: {
                position: "sticky",
                top: 0,
                background: "#012E1D",
                zIndex: 10,
            },
        };
    
        const [open, setOpen] = useState(null);
        const items = [
            { title: "Pongal", qty: "2 Kg's", bgColor: "#e8b6fb" },
            { title: "Idly", qty: "240 No's", bgColor: "#e8b6fb" },
            { title: "Sambar", qty: "20 Ltr", bgColor: "#e8b6fb" },
            { title: "Chilli Chutney", qty: "20 Ltr", bgColor: "#e8b6fb" },
        ];

          // State for each item's dynamic sub-rows
        const [itemRows, setItemRows] = useState(
            items.map(() => [
            { category: null, subcategory: null, cookware: null, units: "" },
            ])
        );

        // Add a sub-row for a particular item
        const handleAddRow = (index) => {
            const newRows = [...itemRows];
            newRows[index].push({ category: null, subcategory: null, cookware: null, units: "" });
            setItemRows(newRows);
        };

        // Delete a sub-row for a particular item
        const handleDeleteRow = (itemIndex, rowIndex) => {
            const newRows = [...itemRows];
            newRows[itemIndex].splice(rowIndex, 1);
            setItemRows(newRows);
        };

        // Handle Select/Input change
        const handleChange = (itemIndex, rowIndex, field, value) => {
            const newRows = [...itemRows];
            newRows[itemIndex][rowIndex][field] = value;
            setItemRows(newRows);
        };

    return (
        <>
            <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0">
                <div className='mb-0'>
                    <div className="mb-0 px-0">
                        <h4 className='breadcrumb-header'>Assign Vessel</h4>
                    </div>
                    <ol className="breadcrumb fs-7">
                        <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                        <li className="breadcrumb-item"><i class="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item active">Production Management</li>
                        <li className="breadcrumb-item"><i class="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item active">Manage Packing</li>
                    </ol>
                </div>
            </div>
            <div className='row mb-2'>
                <div className='row mb-4'>
                    <div className="col-lg-3 d-flex flex-column align-items-start justify-content-start gap-2 mb-2">
                        <label className='text-danger font-w600 fs-5'>Keshvi Shri</label>
                        <label className="fs-7 text-dark">9874514006</label>
                    </div>
                    <div className="col-lg-3 d-flex flex-column align-items-start justify-content-start gap-2 mb-2">
                        <label className='text-danger font-w600 fs-5'>CATOR-015/2025</label>
                        <OverlayTrigger trigger="hover" placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Order Delivery Date                                </span></Tooltip>} >
                            <label className="fs-7 text-dark">20-Aug-2025</label>
                        </OverlayTrigger>
                    </div>
                    <div className='col-lg-3'>
                        <div className='d-flex flex-column align-items-start justify-content-start'>
                            <label className='text-black font-w500 fs-5'>Total Items</label>
                            <label className="fs-5 text-danger font-w500 border border-danger py-1 px-2 rounded">04</label>
                        </div>
                    </div>
                    <div className='col-lg-3'>
                        <div className='d-flex flex-column align-items-start justify-content-start'>
                            <label className='text-black font-w500 fs-5'>Total Cookwares</label>
                            <label className="fs-5 text-danger font-w500 border border-danger py-1 px-2 rounded">134</label>
                        </div>
                    </div>
                    <div className='col-lg-12 mb-2'>
                        <div className='d-flex flex-column align-items-start justify-content-start'>
                            <label className='text-black font-w500 fs-5'>Delivery Address</label>
                            <label className="fs-5 text-dark font-w300">12/A, Bharat Cross Street, Anna Nagar, Madurai -625014</label>
                        </div>
                    </div>
                </div>
                <div className="row mb-2 scroll-y" style={{ minHeight: "450px", overflowY: "auto", overflowX: "hidden" }}>
                    <div className="col-lg-12 mb-2">
                        {items.map((item, index) => {
                        const { title, qty, bgColor } = item;
                        const isOpen = open === index;

                        return (
                            <div key={index} className="border border-gray-500 rounded mb-2">
                            {/* Card Header */}
                            <div
                                className="py-4 px-4 rounded d-flex justify-content-between align-items-center"
                                style={{ backgroundColor: bgColor }}
                            >
                                <div className="d-flex align-items-center gap-3">
                                <label className="text-black font-w500 fs-5">{title}</label>
                                <label className="text-white py-1 px-2 rounded font-w500 fs-6 bg-dark">{qty}</label>
                                </div>

                                {/* Arrow only toggles accordion */}
                                <i
                                className={`fa-solid fs-3 text-black ${
                                    isOpen ? "fa-circle-chevron-up" : "fa-circle-chevron-down"
                                }`}
                                style={{ cursor: "pointer" }}
                                onClick={() => setOpen(isOpen ? null : index)}
                                ></i>
                            </div>

                            {/* Accordion Body */}
                            {isOpen && (
                                <div className="py-4 px-4">
                                {itemRows[index].map((row, rowIndex) => (
                                    <div className="row mb-3" key={rowIndex}>
                                    <div className="col-lg-11">
                                        <div className="row">
                                        <div className="col-lg-3 mb-2">
                                            <label className="text-black font-w500 fs-7">
                                            Cookware Category<span className="required">*</span>
                                            </label>
                                            <Select
                                            placeholder="Select Category"
                                            options={cookwarecat_options}
                                            value={row.category}
                                            onChange={(val) => handleChange(index, rowIndex, "category", val)}
                                            />
                                        </div>
                                        <div className="col-lg-3 mb-2">
                                            <label className="text-black font-w500 fs-7">
                                            Cookware Subcategory<span className="required">*</span>
                                            </label>
                                            <Select
                                            placeholder="Select Subcategory"
                                            options={cookwaresubcat_options}
                                            value={row.subcategory}
                                            onChange={(val) => handleChange(index, rowIndex, "subcategory", val)}
                                            />
                                        </div>
                                        <div className="col-lg-3 mb-2">
                                            <label className="text-black font-w500 fs-7">
                                            Cookware<span className="required">*</span>
                                            </label>
                                            <Select
                                            placeholder="Select Cookware"
                                            options={cookware_options}
                                            value={row.cookware}
                                            onChange={(val) => handleChange(index, rowIndex, "cookware", val)}
                                            />
                                        </div>
                                        <div className="col-lg-3 mb-2">
                                            <label className="text-black font-w500 fs-7">
                                            Units<span className="required">*</span>
                                            </label>
                                            <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter Units"
                                            value={row.units}
                                            onChange={(e) => handleChange(index, rowIndex, "units", e.target.value)}
                                            />
                                        </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-1 d-flex align-items-start justify-content-end">
                                        {/* Show delete only if not first row */}
                                        {rowIndex !== 0 && (
                                        <button
                                            className="btn btn-danger mt-4 px-2 py-2"
                                            onClick={() => handleDeleteRow(index, rowIndex)}
                                        >
                                            <i className="fa-solid fa-trash-can fs-6 text-white"></i>
                                        </button>
                                        )}
                                    </div>
                                    </div>
                                ))}

                                {/* Add More button per item */}
                                <div className="mb-3">
                                    <button
                                    className="btn btn-sm btn-primary"
                                    onClick={() => handleAddRow(index)}
                                    >
                                    <i className="fa-solid fa-plus fs-6"></i>
                                    <span className="ms-2 fs-7">Add More</span>
                                    </button>
                                </div>
                                </div>
                            )}
                            </div>
                        );
                        })}
                    </div>
                </div>
            </div>
            <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4">
                <Link type="submit" to={'/manage-packing'} className="btn btn-sm btn-primary">Assign Vessel
                    <i className="fas fa-angle-double-right ms-2"></i>
                </Link>
            </div>
        </>
    )


}
export default Assign_Vessel_Cat;